import { useTranslation } from "react-i18next";
import { Wallet } from "lucide-react";
import { AuthPage } from "@tabipla/components";
import { useAuth } from "@/application/hooks/useAuth";

const WARITTO_THEME = {
  iconBg: "bg-emerald-500",
  iconText: "text-white",
  buttonClass: "bg-emerald-500 text-white shadow-lg hover:bg-emerald-600",
  backgroundGradient:
    "from-white via-gray-50 to-emerald-50/50 dark:from-gray-950 dark:via-gray-900 dark:to-emerald-950/30",
};

export function LoginPage() {
  const { t } = useTranslation();
  const { login, loginWithLine, isLoading } = useAuth();

  return (
    <AuthPage
      appName="Waritto"
      tagline={t("app.tagline", "仲間と、ポチッと")}
      icon={<Wallet className="h-8 w-8" />}
      theme={WARITTO_THEME}
      mode="login"
      onLogin={login}
      onLoginWithLine={loginWithLine}
      isLoading={isLoading}
    />
  );
}
